import { AuthSchema } from '@/lib/api/schemas/auth.schema';
import { z } from 'zod';

export const RegisterSchema = AuthSchema.extend({
    confirmPassword: z.string(),
}).refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
});

export type RegisterFormValues = z.infer<typeof RegisterSchema>;

export const SetupNewPasswordSchema = z
    .object({
        confirmPassword: z.string(),
        password: z.string().min(8, {
            message: 'Password must be at least 8 characters long',
        }),
    })
    .refine((data) => data.password === data.confirmPassword, {
        message: 'Passwords do not match',
        path: ['confirmPassword'],
    });

export type SetupNewPasswordDto = z.infer<typeof SetupNewPasswordSchema>;
